// JavaScript Document
//components/signs/Types.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/AddCircle';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import TypesTable from './TypesTable';
import CatTable from './category/Table';
import ClassTable from './class/Table';
import Category from './category/Form';
import SignClass from './class/Form';
import TypeForm from './type/Form';
import TypeTable from './type/Table';

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
	maxHeight:'calc(100vh - 64px)',
	//maxHeight: '100%'
  },
  root: {
	  flexGrow: 1,
  },
   paper: {
    padding: theme.spacing(2),
    margin: 'auto'
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}//`

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
	  
function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}
	
/*
{categories.map((row, i) => (
			<TabPanel value={tabNum} index={i+1} key={row.id}>
				<Paper className={classes.paper}>
					<Typography variant="h5" gutterBottom>{row.name}</Typography>
				</Paper>
				<TypesTable handleSend={handleSend} items={typesList.filter(type => parseInt(type.opt_parent) === parseInt(row.id))} />
			</TabPanel>
			))}
*/

export default function Types(props) {
  	const classes = useStyles();
  	const {handleSend} = props;
  	const [loaded, setLoaded] = React.useState(false);
  	const [typesList, setTypesList] = React.useState([]);
	const [btypesList, setBTypesList] = React.useState([]);
	const [categories, setCategories] = React.useState([]);
	const [catEdit, setCatEdit] = React.useState(false);
	const [cat, setCat] = React.useState({});
	const [signClass, setSignClass] = React.useState({});
	const [classEdit, setClassEdit] = React.useState(false);
	const [typeEdit, setTypeEdit] = React.useState(false);
	const [signType, setSignType] = React.useState({});
	const [images, setImages] = React.useState([]);
	const [tabNum, setTabNum] = React.useState(0);
	const [menuAnchor, setMenuAnchor] = React.useState(null);
	const [filters, setFilters] = React.useState({
		category : null,
		class : null
	})
	const menuOpen = Boolean(menuAnchor);
	
  	React.useEffect(() => {
		if(!loaded){
			getTypesList();
		}
	});
  	const getTypesList = () =>{
		setLoaded(true);
		handleSend({
			vso: 'typeslist'
		}, (data) => {
			setTypesList(data.types);
			setBTypesList(data.btypes);
			setCategories(data.categories);
			setImages(data.images);
		});
	}
	//when a tab is clicked
	const handleChangeTab = (event, newValue) => {
		//console.log(newValue);
    	setTabNum(newValue);
  	};
	const handleNew = (event) => {
		setMenuAnchor(event.currentTarget);
		//console.log(event);
	}
	const handleCloseMenu = () => {
		setMenuAnchor(null);
	}
	//Set the transform origin variables for "new" menu
	const menuOrigins = {
		vertical: 'top',
		horizontal: 'left'
	};
	//Render category form
	const renderCategory = () => {
		if(catEdit){
			return (
				<Category
					category={cat}
					handleSend={handleSend}
					pics={images}
					onChange={handleUpdateItem}
				/>
			);
		}
		return '';
	};
	//Render sign class form
	const renderSignClass = () => {
		if(classEdit){
			return (
				<SignClass
					item={signClass}
					handleSend={handleSend}
					pics={images}
					onChange={handleUpdateItem}
				/>
			);
		}
		return '';
	}
	//Render sign type form
	const renderSignType = () => {
		if(typeEdit){
			return (
				<TypeForm
					item={signType}
					handleSend={handleSend}
					pics={images}
					onChange={handleUpdateItem}
					categories={categories}
					signClasses={btypesList}
				/>
			);
		}
		return '';
	}
	//After an item is saved
	const handleUpdateItem = (item, isNew) => {
		if(typeof uitem !== 'object'){
			//delete
			//setItem({});
			//setEdit(false);
			setCatEdit(false);
			setClassEdit(false);
			setTypeEdit(false);
			getTypesList();
			return;
		}
		
		if(item.pic){
			item.pic_path = images.filter(pic => pic.id === item.pic)[0].path;
		}
		var list = [];
		if(item.type === 'sign_category'){
			list = categories;
			setCat(item);
		} else if(item.type === 'sign_class'){
			list = btypesList;
			setSignClass(item);
		} else if(item.type === 'sign_type'){
			list = typesList;
			setSignType(item);
		}
		if(isNew){
			list.push(item);
		} else {
			list.splice(list.findIndex(row => row.id === item.id), 1, item);
		}
		if(item.type === 'sign_category'){
			setCategories(list);
		} else if(item.type === 'sign_class'){
			setBTypesList(list);
		} else if(item.type === 'sign_type'){
			setTypesList(list);
		}
		
	}
	
	//New category menu item clicked
	const handleNewCategory = (e) => {
		setCat({});
		if(catEdit){
			setCatEdit(false);
			setTimeout(()=>{setCatEdit(true)}, 200);
		} else {
			setCatEdit(true);
		}
		//setCatEdit(true);
		setTabNum(1);
		handleCloseMenu();
		
	}
	
	//New sign class menu item clicked
	const handleNewClass = (e) => {
		setSignClass({});
		if(classEdit){
			setClassEdit(false);
			setTimeout(()=>{setClassEdit(true)}, 200);
		} else {
			setClassEdit(true);
		}
		//setCatEdit(true);
		setTabNum(2);
		handleCloseMenu();
	}
	
	//New sign type menu item clicked
	const handleNewType = (e) => {
		setSignType({});
		if(typeEdit){
			setTypeEdit(false);
			setTimeout(()=>{setTypeEdit(true)}, 200);
		} else {
			setTypeEdit(true);
		}
		setTabNum(3);
		handleCloseMenu();
	}
	
	//Handle select item
	const handleSelectItem = (item) => {
		if(item.type === 'sign_category'){
			setCatEdit(true);
			setCat(item);
			setTabNum(1);
		} else if(item.type === 'sign_class'){
			setSignClass(item);
			setClassEdit(true);
			setTabNum(2);
		} else if(item.type === 'sign_type'){
			setSignType(item);
			setTypeEdit(true);
			setTabNum(3);
		}
	}
	
	//Handle any filter changes
	const handleChangeFilter = (e) => {
		var name = e.target.name;
		var value = e.target.value;
		var myFilters = Object.assign({}, filters);
		myFilters[name] = value;
		setFilters(myFilters);
	}
	
	return (
		<div className={classes.root}>
			<Menu
	  			id="new-menu"
	  			anchorEl={menuAnchor}
	  			anchorOrigin={menuOrigins}
	  			keepMounted
	  			transformOrigin={menuOrigins}
	  			open={menuOpen}
	  			onClose={handleCloseMenu}
	  		>
	  			<MenuItem onClick={handleNewCategory}>Category</MenuItem>
	  			<MenuItem onClick={handleNewClass}>Sign Class</MenuItem>
	  			<MenuItem onClick={handleNewType}>Sign Type</MenuItem>
	  		</Menu>
			<AppBar position="static" color="default">
				<Box display="flex">
					<Button
						variant="contained"
						color="primary"
						onClick={handleNew}
						startIcon={<AddIcon />}
					>New</Button>
	    			<Tabs
	  	  				value={tabNum}
	  	  				onChange={handleChangeTab}
	      				indicatorColor="primary"
	  	  				textColor="primary"
	  	  				variant="scrollable"
	  	  				scrollButtons="auto"
	  	  				aria-label="sign tabs"
	    			>
						<Tab label="All" {...a11yProps(0)} />
	  	  				<Tab label="Categories" {...a11yProps(1)} />
						<Tab label="Sign Classes" {...a11yProps(2)} />
						<Tab label="Sign Types" {...a11yProps(3)} />
					</Tabs>
				</Box>
			</AppBar>
			<TabPanel value={tabNum} index={0}>
					<TypesTable handleSend={handleSend} items={categories.concat(btypesList, typesList)} showtype={true} onSelect={handleSelectItem} />
			</TabPanel>
			<TabPanel value={tabNum} index={1}>
				{renderCategory()}
				<CatTable handleSend={handleSend} items={categories} onSelect={handleSelectItem} />
			</TabPanel>
			<TabPanel value={tabNum} index={2}>
				{renderSignClass()}
				<ClassTable handleSend={handleSend} items={btypesList} onSelect={handleSelectItem} />
			</TabPanel>
			<TabPanel value={tabNum} index={3}>
				{renderSignType()}
				<Box display="flex">
				 	<TextField
						id="filter_cat"
						name="category"
						label="Category"
						value={filters.category}
						onChange={handleChangeFilter}
						fullWidth
						select
					>
						<MenuItem value={null}>All</MenuItem>
						{categories.map((row) => (
						<MenuItem value={row.id} key={row.id}>{row.name}</MenuItem>
						))}
					</TextField>
					<TextField
						id="filter_class"
						name="class"
						label="Sign Class"
						value={filters.class}
						onChange={handleChangeFilter}
						fullWidth
						select
					>
						<MenuItem value={null}>All</MenuItem>
						{btypesList.map((row) => (
						<MenuItem value={row.id} key={row.id}>{row.name}</MenuItem>
						))}
					</TextField>
				</Box>
				<TypeTable handleSend={handleSend} items={
					filters.class && filters.category ? 
						typesList.filter(item => 
							item.opt_class === filters.class 
							&& item.opt_cat === filters.category) 
					: filters.class ? typesList.filter(item => item.opt_class === filters.class) 
					: filters.category ? typesList.filter(item => item.opt_cat === filters.category) 
					: typesList} onSelect={handleSelectItem} />
			</TabPanel>
		</div>
  );
}
